module.exports = __webpack_public_path__ + "img/icon_title_4.9153e2bb.svg";